import Modal from './modals';
document.addEventListener('DOMContentLoaded', () => {
    const modalEl = document.getElementById('modal-contact');
    new Modal(modalEl);
});
